module.exports = __webpack_public_path__ + "static/media/halfCircleLightGreen2.6683e649.svg";